import { render, staticRenderFns } from "./ExitSimulatorPage.vue?vue&type=template&id=9afd0eaa&"
import script from "./ExitSimulatorPage.vue?vue&type=script&lang=js&"
export * from "./ExitSimulatorPage.vue?vue&type=script&lang=js&"
import style0 from "./ExitSimulatorPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports